'use client';

import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from '../../forward-ref.js';
import type { CommonProps } from '../types.js';

export interface TableHeaderProps extends CommonProps {
  /** The header rows that belong to this table header. */
  children: ReactNode;
}

function TableHeader(
  { children, UNSAFE_className, UNSAFE_style, ...props }: TableHeaderProps,
  ref: ForwardedRef<HTMLTableSectionElement>,
) {
  return (
    <thead {...props} ref={ref} className={UNSAFE_className} style={UNSAFE_style}>
      {children}
    </thead>
  );
}

/**
 * Renders a header section within a table.
 *
 * See [table usage guidelines](https://ui.cimpress.io/components/table/) and [table building guide](https://ui.cimpress.io/dev-guides/tables/).
 */
const _TableHeader = forwardRef(TableHeader, 'TableHeader');

export { _TableHeader as TableHeader };
